import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "p-fluid" }
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "newusername" }, "Nome", -1)
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "surname" }, "Cognome", -1)
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "email-off" }, "Email", -1)
const _hoisted_13 = { class: "p-fluid" }
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1)
const _hoisted_17 = { class: "p-field" }
const _hoisted_18 = { class: "p-float-label" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "confirm-password" }, "Conferma password", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading && !_ctx.user)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_Skeleton, {
            height: "2rem",
            class: "p-mb-2"
          }),
          _createVNode(_component_Skeleton, {
            height: "2rem",
            class: "p-mb-2"
          }),
          _createVNode(_component_Skeleton, {
            height: "2rem",
            class: "p-mb-2"
          }),
          _hoisted_2,
          _createElementVNode("section", null, [
            _createElementVNode("header", null, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('user.password.title')), 1)
            ]),
            _createVNode(_component_Skeleton, {
              height: "2rem",
              class: "p-mb-2"
            }),
            _createVNode(_component_Skeleton, {
              height: "2rem",
              class: "p-mb-2"
            })
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.user)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                autocomplete: "off",
                onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_InputText, {
                        autocomplete: "off",
                        type: "text",
                        modelValue: _ctx.user.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.user.name = $event))
                      }, null, 8, ["modelValue"]),
                      _hoisted_6
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_InputText, {
                        autocomplete: "off",
                        id: "surname",
                        type: "text",
                        modelValue: _ctx.user.surname,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.user.surname = $event))
                      }, null, 8, ["modelValue"]),
                      _hoisted_9
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_InputText, {
                        autocomplete: "false",
                        id: "email-off",
                        type: "email",
                        modelValue: _ctx.user.email,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.user.email = $event))
                      }, null, 8, ["modelValue"]),
                      _hoisted_12
                    ])
                  ])
                ]),
                _createVNode(_component_Divider),
                _createElementVNode("section", null, [
                  _createElementVNode("header", null, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('user.password.title')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, [
                        _createVNode(_component_InputText, {
                          autocomplete: "new-password",
                          id: "password",
                          type: "password",
                          modelValue: _ctx.user.password,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.user.password = $event))
                        }, null, 8, ["modelValue"]),
                        _hoisted_16
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, [
                        _createVNode(_component_InputText, {
                          autocomplete: "confirm-password",
                          id: "confirm-password",
                          type: "password",
                          modelValue: _ctx.confirmPassword,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmPassword = $event))
                        }, null, 8, ["modelValue"]),
                        _hoisted_19
                      ])
                    ])
                  ])
                ])
              ], 32))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}